import React from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import history from './history';

import { AppLayout } from '@amzn/awsui-components-react/polaris';
// import Breadcrumbs from './components/Breadcrumbs';
import Navigation from './components/Navigation';
import NotificationWrapper from './components/NotificationWrapper';
import Main from './components/Main';

import classnames from 'classnames';

import store from './res/store';


class App extends React.Component {

  render() {
    return (
      <Provider store={store}>
          <Router history={history}>
            <div>
              <AppLayout
                className={classnames({ 'awsui-util-no-gutters': true })}
                // breadcrumbs={<Breadcrumbs/>}
                navigation={<Navigation/>}
                notifications={<NotificationWrapper/>}
                content={<Main/>}
                contentType='default'
                navigationOpen={true}
                toolsHide={true}
              />
            </div>
          </Router>
        </Provider>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/app/App.js